<div
  class="flex max-h-[80vh] flex-col overflow-hidden"
  data-testid="scribe-note-dialog"
>
  <div
    class="flex items-start justify-between gap-3 border-b border-slate-200 px-5 py-3.5"
  >
    <div class="flex items-center gap-3">
      <span
        class="bg-primary-50 text-primary-500 flex h-9 w-9 items-center justify-center rounded-md"
      >
        <mat-icon>auto_awesome</mat-icon>
      </span>
      <div>
        <h3
          class="text-accent-500 m-0 text-base font-semibold"
          data-testid="scribe-note-name"
        >
          {{ nameLabel }}
        </h3>
        <p
          class="m-0 text-xs text-slate-500"
          data-testid="scribe-note-created-at"
        >
          {{ createdAtLabel }}
        </p>
      </div>
    </div>
    <button
      mat-icon-button
      type="button"
      aria-label="Close"
      data-testid="scribe-note-close"
      mat-dialog-close
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="overflow-y-auto px-5 py-4" data-testid="scribe-note-content">
    <pr-content-view [content]="content" />
  </div>

  <div
    class="flex items-center justify-end border-t border-slate-200 bg-slate-50 px-5 py-3.5"
  >
    <button
      mat-stroked-button
      type="button"
      data-testid="scribe-note-close-footer"
      mat-dialog-close
    >
      Close
    </button>
  </div>
</div>
